export default __webpack_public_path__ + "static/media/logo_pwa.234a41d3.png";